import { render, staticRenderFns } from "./complianceReportTable.vue?vue&type=template&id=70417880&scoped=true&"
import script from "./complianceReportTable.vue?vue&type=script&lang=js&"
export * from "./complianceReportTable.vue?vue&type=script&lang=js&"
import style0 from "./complianceReportTable.vue?vue&type=style&index=0&id=70417880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70417880",
  null
  
)

export default component.exports